// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { EmployeeNameResponse } from './employee-name-response';

// @ts-ignore
import { ScheduleItemCalendarResponse } from './schedule-item-calendar-response';

/** See com.rev360.pms.api.controller.schedule.scheduleitem.calendar.AppointmentSlotCalendarResponse */
/* istanbul ignore next */
@GandalfModel
export class AppointmentSlotCalendarResponse extends ScheduleItemCalendarResponse {

	@GandalfProperty({ designType: Number })
	displayColor!: number | null;

	@GandalfProperty({ designType: EmployeeNameResponse })
	employee!: EmployeeNameResponse | null;

	@GandalfArray(String)
	encounterTemplateNames!: string[] | null;

	@GandalfProperty({ designType: Date })
	endDate!: Date | null;

	@GandalfProperty({ designType: Number })
	groupingPersonId!: number | null;

	@GandalfProperty({ designType: Number })
	locationId!: number | null;

	@GandalfProperty({ designType: Number })
	relatedScheduleItemId!: number | null;

	@GandalfProperty({ designType: Number })
	roleId!: number | null;

	@GandalfProperty({ designType: String })
	roleName!: string | null;

	@GandalfProperty({ designType: Number })
	scheduleItemId!: number | null;

	@GandalfProperty({ designType: Date })
	startDate!: Date | null;

	@GandalfConstantDecorator(constants.ScheduleItemStatus)
	@GandalfProperty({ designType: constants.ScheduleItemStatus })
	status!: constants.ScheduleItemStatus | null;

	@GandalfConstantDecorator(constants.ScheduleItemType)
	@GandalfProperty({ designType: constants.ScheduleItemType })
	type!: constants.ScheduleItemType | null;

	@GandalfProperty({ designType: Date })
	updatedOn!: Date | null;

}
